<empty><ng-content></ng-content></empty>
